import { FilterActions } from '@/components/ui/filters/store/actions';
import { FilterGetters } from '@/components/ui/filters/store/getters';
import { FilterMutations } from '@/components/ui/filters/store/mutations';
import { FilterState } from '@/components/ui/filters/store/state';
import { IRootState } from '@/store/state';
import { Module } from 'vuex';
import { IFilterState } from './types';

export const FilterModuleStore: IFilterModuleStore = {
  state: FilterState,
  actions: FilterActions,
  getters: FilterGetters,
  mutations: FilterMutations
};

/**
 * --------------------------------------------------
 *	Filter Store Interface
 * --------------------------------------------------
 **/
export interface IFilterModuleStore extends Module<IFilterState, IRootState> {}
